import React from "react";
import DailyCollectionPanel from "./DailyCollectionPanel";
import PharmacyBillHistoryPanel from "./PharmacyBillHistoryPanel";
import "./PharmacySalesHistoryPanel.css";

export default function PharmacySalesHistoryPanel() {
  return (
    <div className="ph-sales-history">
      <div className="ph-sales-left">
        <DailyCollectionPanel />
      </div>
      <div className="ph-sales-right">
        <PharmacyBillHistoryPanel />
      </div>
    </div>
  );
}

